import { Colours } from "@alienheadwars/football-card-manager-model";
import { Card } from "@mui/material";
import React from "react";
import { InLine } from "../../../../cards/playerCards/CardDimensions";
import { defaultColours } from "../../../../cards/CardColours";



export interface CommentaryCardProps {
    children: React.ReactNode,
    colours?: Colours,
}

export const CommentaryCard = (props: CommentaryCardProps) => {
    const { children } = props
    const colours = props.colours??defaultColours
    return <Card sx={{
        backgroundColor: colours.primaryBackgroundColour,
        color: colours.primaryTextColour ?? 'black',
        fontSize: InLine.playerNameFontSize,
        boxSizing: 'border-box',
        width: 'min(95vw,50vh)',
        textAlign: 'left',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        padding: '1vmin'
    }}>
        {children}
    </Card>
}
